module.exports = __webpack_public_path__ + "static/img/gbLogoEN.e690d35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gbLogoEN.png
// module id = rcEK
// module chunks = 24